module.exports = __webpack_public_path__ + "img/Bild1.fb64593a.jpg";